import * as React from 'react';
import * as styled from './styled';
import {useFormikContext} from 'formik';
import {useBlockContext} from '../../hooks/useBlockContext';
import {CommentObject, TaskObject} from 'api/task/types';
import Switch from 'components/Switch';
import {CommentsProps} from './types';
import SlideDown from 'react-slidedown';

/**
 * The comments of the block.
 * @param {CommentsProps} props
 * @return {React.ReactElement<CommentsProps> | null}
 * @constructor
 */
export default function Comments(
    props: CommentsProps,
): React.ReactElement<CommentsProps> | null {
  const block = useBlockContext();
  const {setFieldValue} = useFormikContext<Partial<TaskObject>>();

  /**
   * Render toggle.
   * @return {JSX.Element}
   */
  function renderToggle(): JSX.Element {
    /**
     * The change event handler.
     * @param {React.ChangeEvent<HTMLInputElement>} event
     * @return {void}
     */
    function handleChange(
      event: React.ChangeEvent<HTMLInputElement>,
    ): void {
      setFieldValue(
        `content.blocks[${block.index}].comment.active`,
        event.target.checked,
      );
    }

    return (
      <Switch
        label="Комментарий к пройденному заданию"
        checked={block.comment?.active}
        onChange={handleChange}
      />
    );
  }

  /**
   * Render comment.
   * @param {'fail' | 'success'} type
   * @return {JSX.Element}
   */
  function renderComment(type: 'fail' | 'success'): JSX.Element {
    /**
     * The change event handler.
     * @param {React.ChangeEvent<HTMLTextAreaElement>} event
     */
    function handleChange(
      event: React.ChangeEvent<HTMLTextAreaElement>,
    ): void {
      setFieldValue(
        `content.blocks[${block.index}].comment.${type}`,
        event.target.value,
      );
    }

    return (
      <styled.Comment>
        <styled.Label type={type}>
          {type === 'fail' && 'Задание пройдено с ошибками'}
          {type === 'success' && 'Задание пройдено верно'}
        </styled.Label>
        <styled.Value
          value={block.comment && block.comment[type]}
          onChange={handleChange}
          placeholder="Введите комментарий"
          required
        />
      </styled.Comment>
    );
  }

  return (
    <styled.Wrapper>
      {renderToggle()}
      <SlideDown closed={!block.comment?.active} transitionOnAppear={false}>
        {renderComment('fail')}
        {renderComment('success')}
      </SlideDown>
    </styled.Wrapper>
  );
}
